export default "__VITE_ASSET__585029b6__"